<!--
 * @Author: your name
 * @Date: 2020-10-20 11:35:44
 * @LastEditTime: 2020-12-25 17:10:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/mine/addcertification/index.vue
-->
<template>
  <div class="add_certification">
    <title-bar-back :title="'实名认证'" @back="back">
      <div class="title_right font14 font_weight400" @click="saveDet">保存</div>
    </title-bar-back>
    <!-- 身份信息 -->
    <title-mes />
    <input-mes
      :border-bottom="true"
      :placeholder="'您的真实姓名'"
      @inputValue="inputValue1"
    />
    <input-mes
      :placeholder="'您的身份证号码（将加密处理）'"
      @inputValue="inputValue2"
    />
    <!-- 手机号 -->
    <title-mes :title="'手机号'" />
    <input-mes
      :placeholder="'与上述实名一致的手机号'"
      @inputValue="inputValue3"
    />
    <!-- 身份证 -->
    <title-mes :title="'身份证正反面照片'" :titleDet="'（选填）'" />
    <!-- 上传 -->
    <div class="up_mine">
      <van-uploader
        :after-read="afterRead1"
        v-model="fileList"
        result-type="file"
        max-count="1"
      >
        <div class="up_item">
          <img src="@/assets/mine/photo@2x.png" alt="" class="up_photo" />
          <div class="font12 font_weight500 colo0">上传身份证人像面</div>
        </div>
      </van-uploader>
      <van-uploader
        v-model="fileList2"
        :after-read="afterRead2"
        result-type="file"
        max-count="1"
      >
        <div class="up_item">
          <img src="@/assets/mine/photo@2x.png" alt="" class="up_photo" />
          <div class="font12 font_weight500 colo0">上传身份证国徽面</div>
        </div>
      </van-uploader>
    </div>
    <!-- 问题说明 -->
    <questions />
  </div>
</template>
<script>
import { idcardMatching } from "@/utils/formatters";
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
import TitleMes from "./components/TitleMes";
import InputMes from "./components/InputMes";
import Questions from "./components/Questions";
export default {
  name: "AddCertification",
  components: {
    TitleBarBack,
    TitleMes,
    InputMes,
    Questions
  },
  data() {
    return {
      fileList: [],
      fileListImage: [],
      fileList2: [],
      fileListImage2: [],
      idcardName: "",
      idcardNumber: "",
      idcardFrontUrl: "身份证正面照片",
      idcardBackUrl: "身份证背面照片",
      phone: "",
      certificateType: "1"
    };
  },
  methods: {
    back() {
      this.$router.back();
    },
    saveDet() {
      // 保存实名认证 addCertification
      const reg = /^(1[3456789])\d{9}$/;
      if (!this.idcardName.trim()) {
        this.$toast("请输入姓名");
        return;
      }
      if (
        !this.idcardNumber.trim() ||
        !idcardMatching.format(this.idcardNumber.toLocaleUpperCase())
      ) {
        this.$toast("请输入正确的身份证号");
        return;
      }
      if (!reg.test(this.phone.trim())) {
        this.$toast("请输入正确的手机号");
        return;
      }
      const params = {
        kind: "Registered",
        idcardName: this.idcardName.trim(),
        idcardNumber: this.idcardNumber.trim().toLocaleUpperCase(),
        phone: this.phone.trim(),
        certificateType: this.certificateType
      };
      if (this.fileList.length) {
        params.idcardFrontUrl = this.fileList[0].url; //正面
      }
      if (this.fileList2.length) {
        params.idcardBackUrl = this.fileList2[0].url; //背面
      }
      this.$store
        .dispatch("mine/addCertification", { params })
        .then(() => {
          this.$router.back();
        })
        .catch(() => {});
    },
    // afterRead(file) {
    //   // 此时可以自行将文件上传至服务器
    //   console.log(file);
    // },
    // 姓名
    inputValue1(value) {
      this.idcardName = value;
    },
    // 身份证号
    inputValue2(value) {
      this.idcardNumber = value;
    },
    // 手机号
    inputValue3(value) {
      this.phone = value;
    },
    // 上传图片
    afterRead1(file) {
      // console.log(file);
      // 此时可以自行将文件上传至服务器
      // this.$route.query.id
      this.$store
        .dispatch("mine/upload", {
          params: {
            file: file.file,
            data: {
              kind: "identity",
              sourceId: this.$route.query.id, //userId
              thumbnail: true
            }
          }
        })
        .then(res => {
          // console.log(res, "res");
          this.$set(this.fileList, 0, { url: res.linkUrl });
        })
        .catch(() => {});
    },
    // 上传图片
    afterRead2(file) {
      // 此时可以自行将文件上传至服务器
      this.$store
        .dispatch("mine/upload", {
          params: {
            file: file.file,
            data: {
              kind: "identity",
              sourceId: this.$route.query.id, //userId
              thumbnail: true
            }
          }
        })
        .then(res => {
          // console.log(res, "res");
          this.$set(this.fileList2, 0, { url: res.linkUrl });
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="less" scoped>
.add_certification {
  .title_right {
    width: 36px;
    color: #bf9264;
    line-height: 40px;
  }
  .up_mine {
    background: #fff;
    display: flex;
    justify-content: space-around;
    padding: 24px 0;
    .up_item {
      background: #f6f7f8;
      border-radius: 6px;
      padding: 16px 22px;
      .up_photo {
        width: 34px;
      }
    }
  }
  ::v-deep .van-uploader__preview-image {
    width: 140px;
    height: 95px;
    border-radius: 6px;
  }
  ::v-deep .van-uploader__preview {
    padding: 0;
  }
}
</style>
